import { FormattedMessage, defineMessages } from 'react-intl';

const addOnIdToName: { [key: string]: any } = defineMessages({
  // 5，9，11缺少翻译，tedd确认是印尼才有的，这里先注释掉
  1: { id: 'Riot, Strike, Civil Commotion' },
  2: { id: 'Terrorism and Sabotage' },
  3: { id: 'Typhoon, Storm, Hail, Flood, and Landslide' },
  4: { id: 'Earthquakes, Volcanic Eruptions and Tsunamis' },
  // 5: { id: 'Autocillin Feature' },
  6: { id: 'Personal Accident for Drivers' },
  7: { id: 'Personal Accident for Passengers' },
  8: { id: 'Legal Liability to Third Parties' },
  // 9: { id: 'Autocillin Workshop Facility' },
  10: { id: 'Ultimate Service Sompo' },
  // 11: { id: 'Water Hammer' },
  12: { id: 'Riot, Strike, Civil Commotion,Terrorism and Sabotage' },
  13: { id: 'Theft by Own Driver' },
  14: { id: 'Wheel and Tire' },
});

export default addOnIdToName;
